module.exports = __webpack_public_path__ + "static/scale-model-of-explore-elgin-area-in-elgin-illinois-c5d7235e57cdc6c4e85364379b719099.png";